import * as React from "react";
import { FontSizes, FontWeights } from "@fluentui/react";
import ReturnBack from "../Components/ReturnBack";

export default function AppContent(props) {
    const margins = props.margins !== undefined ? props.margins : 20;
    const styles = props.style !== undefined ? props.style: [];
    return (
        <div style={{width: `100%`, marginLeft: margins, paddingRight: margins, paddingTop: 10, overflow: 'auto', position: "relative", ...styles}} data-is-scrollable="true">
            {props.delete && <div style={{position: "absolute", top: 10, right: 10}}>{props.delete}</div>}
            {props.backTo && <div style={{position: "absolute", top: 10, left: 10}}><ReturnBack to={props.backTo}/></div>}
            {props.subtitle && <p style={{fontSize: FontSizes.size18, fontWeight: FontWeights.light, margin: 0}}>{props.subtitle}</p>}
            {props.title && <h1 style={{fontSize: FontSizes.size42, fontWeight: FontWeights.light, marginTop: 0}}>{props.title}</h1>}
            {props.innerTitle && <h3 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.regular, margin: 0}}>{props.innerTitle}</h3>}
            {props.children}
        </div>
    )
}